// prop-types is a library for typechecking of props

// @mui material components
import Grid from "@mui/material/Grid";

// Kaizen Dashboard components
import curved9 from "assets/images/curved-images/curved0.jpg";
import SoftBox from "components/SoftBox";

import SoftTypography from "components/SoftTypography";

// Kaizen Dashboard examples
import PageLayout from "components/LayoutContainers/PageLayout";

// Authentication layout components
import { Card, Icon, Slide } from "@mui/material";
import logo from "assets/images/logo_alt.png";
import Footer from "components/Footer";
import SoftButton from "components/SoftButton";
import { useRef, useState } from "react";
import CrearCuenta from "../components/CrearCuentaAlumno";
import background from "assets/images/background_signin.jpg";

function Preinscripcion() {
  const [step, setStep] = useState(0);
  const [usuario, setUsuario] = useState(null);
  const [idUser, setIdUser] = useState(null);
  const [carrera, setCarrera] = useState(null);
  const [openModalCertificado, setOpenModalCertificado] = useState(false);
  const containerRef = useRef(null);

  return (
    <PageLayout>
      <SoftBox
        width="calc(100% - 2rem)"
        minHeight="50vh"
        borderRadius="lg"
        mx={2}
        my={2}
        pt={6}
        pb={28}
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            curved9 &&
            `${linearGradient(
              rgba(gradients.gobPrimary.main, 0.9),
              rgba(gradients.gobPrimary.state, 0.6)
            )}, url(${background})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Grid container spacing={3} justifyContent="center" sx={{ textAlign: "center" }}>
          <Grid item xs={10} lg={4}>
            <SoftBox mt={6} mb={1}>
              <img src={logo} alt="Gobierno de la Provincia de San Luis" width="50%" />
            </SoftBox>
            <SoftBox mb={2}>
              <SoftTypography variant="h4" color="white" fontWeight="bold">
                Crear cuenta
              </SoftTypography>
              <SoftTypography variant="body2" color="white" fontWeight="regular">
                Accedé a tu cuenta de residuos peligrosos online
              </SoftTypography>
            </SoftBox>
          </Grid>
        </Grid>
      </SoftBox>
      <SoftBox
        mt={{ xs: -28, lg: -26 }}
        mb={5}
        px={1}
        width="calc(100% - 2rem)"
        mx="auto"
        ref={containerRef}
      >
        <Slide
          direction="up"
          in={step === 0}
          mountOnEnter
          unmountOnExit
          container={containerRef.current}
        >
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={11} md={7} lg={4} xl={3}>
              <Card>
                <SoftBox p={3}>
                  <SoftBox display="flex" justifyContent="center">
                    <Icon color="primary" sx={{ fontSize: "100px !important" }}>
                      person_add
                    </Icon>
                  </SoftBox>
                  <SoftBox mt={2}>
                    <SoftTypography variant="h5" align="center">
                      Crear una cuenta
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox mt={1}>
                    <SoftTypography variant="h6" align="center" fontWeight="light">
                      A continuación podrá completar el formulario para crear una nueva cuenta para
                      el sistema de residuos peligrosos.
                    </SoftTypography>
                  </SoftBox>
                  <SoftBox mt={2}>
                    <SoftButton color="gobSecondary" fullWidth onClick={() => setStep(1)}>
                      Comenzar &nbsp;
                      <Icon sx={{ fontWeight: "light" }}>arrow_forward</Icon>
                    </SoftButton>
                  </SoftBox>
                  <SoftBox mt={1}>
                    <SoftButton
                      color="primary"
                      variant="text"
                      fullWidth
                      onClick={() => (window.location.href = "/login")}
                    >
                      Ya tengo cuenta &nbsp;
                      <Icon sx={{ fontWeight: "light" }}>arrow_back</Icon>
                    </SoftButton>
                  </SoftBox>
                </SoftBox>
              </Card>
            </Grid>
          </Grid>
        </Slide>
        <Slide
          direction="up"
          in={step === 1}
          mountOnEnter
          unmountOnExit
          container={containerRef.current}
        >
          <Grid container spacing={1} justifyContent="center">
            <Grid item xs={12} md={6} lg={6} xl={6}>
              <Card>
                <CrearCuenta
                  handleCancel={() => setStep(0)}
                  handleSuccess={(usuario, carrera) => {
                    setUsuario(usuario);
                    setCarrera(carrera);
                    setStep(2);
                  }}
                  setIdUser={setIdUser}
                />
              </Card>
            </Grid>
          </Grid>
        </Slide>
      </SoftBox>
      <SoftBox py={3}>
        <Footer />
      </SoftBox>
    </PageLayout>
  );
}

export default Preinscripcion;
